import { lazy, useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import MainLayout from "../layout/mainLayout";

const Dashboard = lazy(() => import("../pages/dashboard/dashboard"));
const Orders = lazy(() => import("../pages/orders/orders"));
const OrderView = lazy(() => import("../pages/orders/orderView"));
const Vendor = lazy(() => import("../pages/vendor/vendor"));
const AddVendor = lazy(() => import("../pages/vendor/addvendor"));
const ViewVendor = lazy(() => import("../pages/vendor/viewVendor"));
const Customers = lazy(() => import("../pages/customer/customer"));
const ViewCustomer = lazy(() => import("../pages/customer/viewCustomer"));
const Banner = lazy(() => import("../pages/banner/banner"));
const SubAdmin = lazy(() => import("../pages/subAdmin/subAdmin"));
const AddSubAdmin = lazy(() => import("../pages/subAdmin/addSubAdmin"));
const Products = lazy(() => import("../pages/products/products"));
const AddProducts = lazy(() => import("../pages/products/addProducts"));
const AddBanner = lazy(() => import("../pages/banner/addBanner"));
const Profile = lazy(() => import("../pages/profile/profile"));
const PriceList = lazy(() => import("../pages/priceRules/index"));
const AddPrice = lazy(() => import("../pages/priceRules/addPrice"));
const AddTransactionFee = lazy(() => import("../pages/priceRules/addTransaction"));
const Notifications = lazy(() => import("../pages/notifications/notifications"));
const Loyalty = lazy(() => import("../pages/loyalty/loyalty"));
const AddLoyalty = lazy(() => import("../pages/loyalty/addLoyalty"));
const ViewLoyalty = lazy(() => import("../pages/loyalty/viewLoyalty"));
const PromoCodes = lazy(() => import("../pages/promoCodes/promoCodes"));
const AddPromoCodes = lazy(() => import("../pages/promoCodes/addPromoCodes"));
const Tax = lazy(() => import("../pages/tax/tax"));
const AddTax = lazy(() => import("../pages/tax/addTax"));
const AnalyticsOverview = lazy(() => import("../pages/agentAnalytics/index"));
const Analytics = lazy(() => import("../pages/analytics/index"));
const CMS = lazy(() => import("../pages/cms/cms"));
const FAQ = lazy(() => import("../pages/faq/faq"));
const AddFaq = lazy(() => import("../pages/faq/addFaq"));
const Refund = lazy(() => import("../pages/refund/index"));
const RefundView = lazy(() => import("../pages/refund/refundView"));
const ContactSupport = lazy(() => import("../pages/contactSupport/contactSupport")); 
const UpdateContactSupport = lazy(() => import("../pages/contactSupport/updateContactSupport"));
const MasterProducts = lazy(() => import("../pages/masterProducts/index"));
const AddMaster = lazy(() => import("../pages/masterProducts/addMaster"));

const LoginChecker = () => {
    const location = useLocation();
    const [loginCheck, setLoginCheck] = useState(sessionStorage.getItem("refreshToken") ? true : false);

    useEffect(() => {
        setLoginCheck(sessionStorage.getItem("refreshToken") ? true : false);
    }, [location]); // re-check when route changes

    return loginCheck ? <Outlet /> : <Navigate to="/" replace />;
};

export const privateRoutes = [
    {
        path: "/home",
        element: <LoginChecker />,
        children: [
            {
                element: <MainLayout />,
                children: [
                    { index: true, element: <Navigate to="dashboard" replace /> }, // default redirect
                    { path: "dashboard", element: <Dashboard /> },
                    { path: "orders", element: <Orders /> },
                    { path: "orders-view", element: <OrderView /> },
                    { path: "vendor", element: <Vendor /> },
                    { path: "customers", element: <Customers /> },
                    { path: "view-customer", element: <ViewCustomer /> },
                    { path: "banner", element: <Banner /> },
                    { path: "add-banner", element: <AddBanner /> },
                    { path: "add-vendor", element: <AddVendor /> },
                    { path: "view-vendor", element: <ViewVendor /> },
                    { path: "sub-admin", element: <SubAdmin /> },
                    { path: "add-sub-admin", element: <AddSubAdmin /> },
                    { path: "products", element: <Products /> },
                    { path: "add-products", element: <AddProducts /> },
                    { path: "price-rules", element: <PriceList /> },
                    { path: "add-price-rules", element: <AddPrice /> },
                    { path: "add-transaction-fee", element: <AddTransactionFee /> },
                    { path: "profile", element: <Profile /> },
                    { path: "notifications", element: <Notifications /> },
                    { path: "loyalty", element: <Loyalty /> },
                    { path: "add-loyalty-card", element: <AddLoyalty /> },
                    { path: "loyalty-card-view", element: <ViewLoyalty /> },
                    { path: "promo-codes", element: <PromoCodes /> },
                    { path: "add-promo-codes", element: <AddPromoCodes /> },
                    { path: "tax", element: <Tax /> },
                    { path: "add-tax", element: <AddTax /> },
                    { path: "agentOverview", element: <AnalyticsOverview /> },
                    { path: "analytics", element: <Analytics /> },
                    { path: "cms", element: <CMS /> },
                    { path: "faq", element: <FAQ /> },
                    { path: "add-faq", element: <AddFaq /> },
                    { path: "refund", element: <Refund /> },
                    { path: "refund-view", element: <RefundView /> },
                    { path: "contact-support", element: <ContactSupport /> },
                    { path: "update-contact-support", element: <UpdateContactSupport /> },
                    { path: "master", element: <MasterProducts /> },
                    { path: "add-master", element: <AddMaster /> },
                ],
            },
        ],
    },
];